<template>
    <div>
        <el-row>
            <el-col><div class="grid-content title">{{ title }}</div></el-col>
        </el-row>
        <el-row>
            <el-col><div class="grid-content amount">{{ amount | numberify}}</div></el-col>
        </el-row>
    </div>
</template>
<script>
export default {
    props: ['title', 'amount'],
    filters: {
        numberify: function (value) {
            if (!value) return '0'
            return new Intl.NumberFormat().format(Math.trunc(value))
        }
    }
}
</script>
<style scoped>
  .el-row {
    margin-bottom: 5px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #d3dce6;
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 10px;
  }
  .row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
  }
  .title {
    font-size: 14px;
    text-align: left;
    color: #909399;
    text-transform: uppercase;
  }
  .amount {
    font-size: 25px;
    text-align: left;
  }
</style>